import Code from '@components/code';

/* global highlight_worker -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
$(() => {
    Code.init(null, highlight_worker);
});
